import { type IntlShape } from 'react-intl';

export const ENHANCE_DRAFT_DESCRIPTORS = (
  formatMessage: IntlShape['formatMessage']
) => ({
  buttonText: formatMessage({
    id: 'app.views.performance.performance_person_assessment.partial.generate_draft_with_ai',
    defaultMessage: 'Enhance Draft with AI ',
  }),
  title: formatMessage({
    id: 'app.views.ai.common.generic_aux.partial.title',
    defaultMessage: 'Use AI to strengthen your draft',
  }),
  loaderText: formatMessage({
    id: 'app.views.ai.common.generic_aux.partial.loader_text',
    defaultMessage: 'Generating enhancements...',
  }),
  submitButtonTitle: formatMessage({
    id: 'app.views.ai.common.generic_aux.partial.submit_button_title',
    defaultMessage: 'Generate Enhancements',
  }),
});

export const FIRST_DRAFT_DESCRIPTORS = (
  formatMessage: IntlShape['formatMessage']
) => ({
  buttonText: formatMessage({
    id: 'app.views.performance.performance_person_assessment.generate_draft_with_ai',
    defaultMessage: 'Generate Draft with AI ',
  }),
  title: formatMessage({
    id: 'app.views.ai.common.generic_aux.title',
    defaultMessage: 'Let AI write your first draft',
  }),
  loaderText: formatMessage({
    id: 'app.views.ai.common.generic_aux.loader_text',
    defaultMessage: 'Generating...',
  }),
  submitButtonTitle: formatMessage({
    id: 'app.views.ai.common.generic_aux.submit_button_title',
    defaultMessage: 'Generate',
  }),
});
